export enum FormFactor {
  Bicycle = 'bicycle',
  Car = 'car',
  Moped = 'moped',
  Scooter = 'scooter',
  Other = 'other',
}
